/** Web's `SIGNUP_TRIGGERS.IMPORT_CLUB`, restated to avoid the import. */
export const IMPORT_CLUB_TRIGGER = "import_club";
let reporter = null;
export const setSignupContextReporter = (next) => {
    reporter = next;
};
export const storeSignupContext = (trigger, options) => reporter?.(trigger, options);
//# sourceMappingURL=signupContextPort.js.map